export default {
  CareConnect: 'CareConnect',
  Onboarding: 'Onboarding',
  ChatWindow: {
    Loading: 'Loading',
    InputPlaceholder: 'Type your message...',
    LoadingMessage: 'AI is typing...',
  },
  FormPreview: {
    Title: 'Form Preview',
    ClientInformation: 'Client Information',
    MedicalHistory: 'Medical History',
    CareRoutine: 'Care Routine',
    CareSchedule: 'Care Schedule',
    CaregiverPreferences: 'Caregiver Preferences',
  },
  InformationBox: {
    Name: 'Name',
    Address: 'Address',
    Condition: 'Conditions',
    Medication: 'Medications',
    Task: 'Tasks',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    Personality: 'Personality',
  },
};
